import BaseScene from './BaseScene';
// Configurations
import { GameConfig } from '../utils/GameConfig';

export class PreloadScene extends BaseScene {
	progressBar;
	progressBox;
	textLoading;

	constructor() {
		super({ key: 'PreloadScene' });
	}

	preload() {
		// create preloader
		this.progressBar = this.add.graphics();
		this.progressBox = this.add.graphics();
		this.progressBar.depth = 20;
		this.progressBox.depth = 19;
		this.textLoading = this.add.bitmapText(this.centerX - 50, this.centerY - 50, 'gameFont_0', 'Loading', 41, 1);

		this.load.on('progress', value => {
			this.progressBox.clear();
			this.progressBox.fillStyle(0xffffff, 1);
			this.progressBox.fillRect(this.centerX - 10 - 160, this.centerY - 10, 320, 50);
			//console.log(value);
			this.progressBar.clear();
			this.progressBar.fillStyle(0x3a965d, 1);
			this.progressBar.fillRect(this.centerX - 160, this.centerY, 300 * value, 30);
		});

		this.load.on('fileprogress', file => {
			//console.log('fileprogress: ' + file.src);
		});

		this.load.on('complete', () => {
			//console.log('complete');
			this.progressBar.destroy();
			this.progressBox.destroy();
			this.textLoading.destroy();
			this.scene.start('RouletteScene');
		});

		// 1) loading png images, sprite sheets
		GameConfig.sprites.forEach(s => {
			if (s.fileName != null) {
				if (this.textures.exists(s.name)) this.textures.remove(s.name); // uncomment for game with multiple slot scenes
				this.load.image(s.name, 'images/' + s.fileName);
			}
		});
	}
}
